import { useMutation } from '@tanstack/react-query';

import type { MutationFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

/**
 * Marks a BEAMS extracted table as inaccurate.
 *
 * NOTE: this is one way. The table is preserved on the backend so the extraction stays
 * available as feedback on BEAMS' output, but there is no way to un-dismiss it.
 */
export const useDismissExtractedTable: MutationFunction<
  null,
  { extractedTableId: number },
  []
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: ({ extractedTableId }: { extractedTableId: number }) =>
      request(`/parts/extracted_tables/${extractedTableId}`, {
        init: { method: 'DELETE' },
      }),
    mutationKey: ['dismiss', 'extractedTable'],
    ...queryOptions,
  });
};
